import { useBackend } from '@/backend';

/**
 * Every active pair's rates *for this requester*, plus the class they are on.
 * The body differs per user, so it must never be shared between accounts —
 * `useBackend` already keys the cache by access token.
 */
export const useMyTradeFees = (enabled = true) =>
  useBackend(
    'wealth:get:trade-fees/',
    {},
    { enabled, swrOptions: { dedupingInterval: 1000 * 60 } },
  );

/** The public ladder. Identical for every requester; an empty array is normal. */
export const useFeeTiers = () =>
  useBackend(
    'wealth:get:trade-fees/tiers/',
    {},
    { swrOptions: { dedupingInterval: 1000 * 60 } },
  );
